import { MarketingPage } from './HostfullyAccountingMarketing.styles';
import BenefitsSection from './sections/BenefitsSection';
import BuiltInSection from './sections/builtInSection/BuiltInSection';
import ClosingSection from './sections/ClosingSection';
import FeaturesSection from './sections/FeaturesSection';
import HeroSection from './sections/heroSection/HeroSection';
import MadeSimpleSection from './sections/MadeSimpleSection';

const HostfullyAccountingMarketing = () => {
  return (
    <MarketingPage data-testid="hostfully-accounting-marketing">
      <HeroSection />
      <MadeSimpleSection />
      <FeaturesSection />
      <BuiltInSection />
      <BenefitsSection />
      <ClosingSection />
    </MarketingPage>
  );
};

export default HostfullyAccountingMarketing;
